/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./UserMini.vue?vue&type=template&id=7bc06195"
import script from "./UserMini.ts?vue&type=script&lang=ts&external"
export * from "./UserMini.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports